export default __webpack_public_path__ + "static/media/06.12c1798c.svg";